import React from 'react';
import PropTypes from 'prop-types';
import { Container, Content } from './styles';

// Importando componentes
import Sidebar from '~/components/Sidebar';
import Header from '~/components/Header';

export default function DefaultLayout({ children }) {
  return (
    <Container>
      <Sidebar />
      <Content>
        <Header />
        {children}
      </Content>
    </Container>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
